var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{attrs:{"name":_vm.$zircle.getNavigationMode() === 'forward' ? 'z-next' : 'z-prev',"tag":"section"}},[_vm._l((_vm.views),function(view){return _c(view.component,{key:view.name,tag:"component",class:{
      'is-current-view': _vm.$zircle.getCurrentViewName() === view.name && _vm.$zircle.getRouterState() === false,
      'is-previous-view': _vm.$zircle.getPreviousViewName() === view.name,
      'is-past-view': _vm.$zircle.getPastViewName() === view.name
    }})}),(_vm.$zircle.getRouterState() === true && _vm.$zircle.getHistoryLength() >= 1)?_c('router-view',{key:_vm.$zircle.getCurrentViewName(),staticClass:"is-current-view"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }